<template>
    <fragment>
        <usage-comparison-options-toolbar
            v-model="configuration"
            @input="loadServiceComparisons()"
            :loading="$wait.is('loadServiceComparisons')"
            :segregate-types="['products', 'services']"
        ></usage-comparison-options-toolbar>
        <service-comparisons-table
            v-if="configuration.segregateBy === 'services'"
            :items="comparisons"
            :currency="tenantStore.currencyCode"
        ></service-comparisons-table>
        <product-comparisons-table
            v-else-if="configuration.segregateBy === 'products'"
            :items="comparisons"
            :currency="tenantStore.currencyCode"
        ></product-comparisons-table>
    </fragment>
</template>

<script>
import { waitFor } from '@/plugins/vue-wait';
import ApiV2 from '@/lib/ApiV2';
import ServiceComparisonsTable from '@/components/Domain.Services/ServiceComparisonsTable.vue';
import ProductComparisonsTable from '@/components/Domain.Products/ProductComparisonsTable.vue';
import UsageComparisonOptionsToolbar from '@/components/Domain.Usage/UsageComparisonOptionsToolbar.vue';
import { useTenantStore } from '../../stores/tenant.ts';
import { mapStores } from 'pinia';

export default {
    components: { ServiceComparisonsTable, ProductComparisonsTable, UsageComparisonOptionsToolbar },
    props: ['value', 'loading'],
    data() {
        return {
            comparisons: [],
            configuration: { segregateBy: 'services', period: 'month', toDate: new Date() },
        };
    },
    watch: {
        value: {
            handler(sub) {
                if (!sub) return;
                this.loadServiceComparisons();
            },
            immediate: true,
        },
    },
    computed: {
        ...mapStores(useTenantStore)
    },
    methods: {
        loadServiceComparisons: waitFor('loadServiceComparisons', async function loadCompare() {
            if (!this.value) return;
            const params = {
                subscriptionIds: this.value.subscriptionId,
                orderBy: 'delta',
                period: this.configuration.period,
                toDate: this.configuration.toDate.toISOString(),
            };
            const response = await ApiV2.http
                .get(`/api/cost-explorer/${this.configuration.segregateBy}`, { params })
                .then((r) => r.data);
            this.comparisons = response.entities;
        }),
    },
};
</script>